<script>
export default {
    name: 'OrderItem',
    props: {
        model: null,
        locale: null,
        currency: null,
        noBorder: Boolean,
        showPrice: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        originalPrice() {
            return this.model?.meal?.original_price
        },
        sortedOptions() {
            return Object.values(
                this.sortNull(this.model.children, 'group_position').reduce((p, c) => {
                    if (!p[c.group_position]) p[c.group_position] = []
                    p[c.group_position].push(c)
                    return p
                }, {})
            ).map((group) => this.sortNull(group, 'meal_option_position'))
        },
    },
}
</script>

<template lang="pug">
.row.no-gutters.py-3(v-if="model")
    .col-12(v-if="!noBorder")
        hr
    .col-40
        .text-nowrap
            | {{model.quantity}}
            icon.ml-2(icon="fa-solid fa-times" size="xs")
    .col
        p(:class="model.children ? 'mb-1' : mb-0") {{model.name}}
        template(v-for="(optionGroup, optionGroupIndex) in sortedOptions")
            span.separator.text-73.text-sm(v-for="(option, optionIndex) in optionGroup" :key="`orderExtra-${optionGroupIndex}-${optionIndex}`")
                span.text-xs(v-if="option.quantity > 1")
                    | {{option.quantity}}
                    icon.ml-1.mr-2(icon="fa-solid fa-times" size="sm")
                | {{option.name}} ({{ option.price | toCurrency(locale, currency) }})
    .col-auto(v-if="showPrice")
        .text-nowrap
            s.mr-lg-3.line-1(v-if="originalPrice !== model.price") {{originalPrice | toCurrency(locale, currency)}}
            | {{ model.price | toCurrency(locale, currency) }}

</template>
